import React, { FC, useState } from 'react';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import EmojiEmotionsIcon from '@material-ui/icons/EmojiEmotions';

import EmojiFormWidgetPicker from './Picker/Picker';
import { colors } from '../../../../themes/colors';

const styles = (theme) =>
  createStyles({
    emojiIconWrapper: {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      marginRight: 10,
    },
    emojiIcon: {
      color: colors.gray5,
      fontSize: 28,
    },
    emojiPickerVeil: {
      cursor: 'initial',
      height: '100vh',
      left: 0,
      position: 'absolute',
      top: 0,
      width: '100vw',
      zIndex: 5,
    },
  });

type Props = {
  onChange: ({ native }: { native: string }) => void;
} & WithStyles;

const EmojiFormWidget: FC<Props> = ({ classes, onChange }) => {
  const [emojiPickerVisible, setEmojiPickerVisible] = useState<boolean>(false);

  const handleEmojiPick = ({ native }: { native: string }) => {
    onChange({ native });
    setEmojiPickerVisible(false);
  };

  return (
    <>
      <div className={classes.emojiIconWrapper} onClick={() => setEmojiPickerVisible(true)}>
        <EmojiEmotionsIcon className={classes.emojiIcon} />
      </div>

      {emojiPickerVisible && (
        <div className={classes.emojiPickerVeil} onClick={() => setEmojiPickerVisible(false)} />
      )}

      <EmojiFormWidgetPicker isVisible={emojiPickerVisible} onClick={handleEmojiPick} />
    </>
  );
};

export default withStyles(styles)(EmojiFormWidget);
